import { Platform, StyleSheet } from 'react-native';
import { colors, spacing, ticketColors, ticketFonts, typography } from '../../shared/theme/public-api';
import { ticketControls } from '../ticket/ticketControls.styles';

export const posSharedUi = StyleSheet.create({
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.45)',
    justifyContent: 'center',
    padding: spacing.md,
  },
  modalCard: {
    backgroundColor: ticketColors.paper,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    padding: spacing.md,
    gap: spacing.sm,
    alignSelf: 'center',
    width: '100%',
    maxWidth: 760,
  },
  modalTitle: {
    ...typography.title3,
    color: ticketColors.ink,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
  checkoutHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  modalInput: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    paddingHorizontal: spacing.sm,
    paddingVertical: Platform.OS === 'ios' ? 10 : 8,
    color: ticketColors.ink,
    backgroundColor: ticketColors.paper,
    fontFamily: ticketFonts.sans,
  },
  /**
   * Bloque informativo / formulario en modales. Para ítems de lista usar `DenseListCard`.
   * @deprecated En listados nuevos preferir `DenseListCard` (barra neutra, system.md).
   */
  paymentCard: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    borderRadius: 14,
    padding: spacing.sm,
  },
  primaryButton: {
    minHeight: 48,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    borderWidth: 0,
    borderColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.md,
  },
  primaryButtonText: {
    fontSize: 15,
    color: ticketColors.goldInk,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
  secondaryButton: {
    minHeight: 48,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.md,
  },
  secondaryButtonText: {
    fontSize: 15,
    color: ticketColors.ink,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },
  disabledCard: {
    opacity: 0.5,
  },
  loadingBox: {
    paddingVertical: spacing.md,
    alignItems: 'center',
    gap: spacing.xs,
  },
  caption: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  sectionTitle: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
  sectionHint: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  summaryHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
  },
  linkText: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '700',
    textDecorationLine: 'underline',
    fontFamily: ticketFonts.sans,
  },
  readOnlyBanner: {
    borderWidth: 1,
    borderColor: colors.warning,
    borderRadius: 10,
    backgroundColor: ticketColors.paper2,
    padding: spacing.sm,
  },
  readOnlyText: {
    ...typography.caption,
    color: colors.warning,
    fontWeight: '700',
  },
  stockNoticeCard: {
    borderWidth: 1,
    borderColor: colors.warning,
    backgroundColor: 'rgba(250, 204, 21, 0.1)',
    borderRadius: 10,
    padding: spacing.sm,
  },
  policyRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  methodChip: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 999,
    paddingHorizontal: spacing.sm,
    paddingVertical: 6,
    backgroundColor: ticketColors.paper,
  },
  methodChipSelected: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  methodChipText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },
  methodChipTextSelected: {
    color: ticketColors.gold,
  },
  modalActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  modalActionsStack: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: spacing.sm,
  },
  modalButtonHalf: {
    flex: 1,
    minWidth: 0,
  },
  modalActionFullWidth: {
    width: '100%',
  },
  checkoutStatusBox: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    backgroundColor: ticketColors.paper2,
    padding: spacing.sm,
    gap: spacing.xs,
  },
  lookupFeedback: {
    ...typography.caption,
    color: colors.textSecondary,
  },
  hidSearchHint: {
    ...typography.caption,
    color: colors.textMuted,
  },
  searchSectionProminent: {
    gap: spacing.xs,
  },
  searchSectionLabel: {
    ...typography.caption,
    color: colors.textMuted,
    fontWeight: '700',
  },
  searchSectionLabelCompact: {
    ...typography.caption,
    color: colors.textMuted,
  },
  searchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
  },
  searchRowProminent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  searchInputOuter: {
    ...ticketControls.searchOuter,
  },
  searchInputInnerNoBorder: {
    ...ticketControls.searchInput,
  },
  searchClearInline: {
    ...ticketControls.searchClear,
  },
  searchScanProminent: {
    ...ticketControls.scanBtn,
  },
  searchScanProminentLabel: {
    ...ticketControls.scanLabel,
  },
  /** Un solo recuadro: campo + limpiar + SCAN + slot final (fila horizontal). */
  catalogUnifiedSearchBox: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: spacing.sm,
    minHeight: 42,
    paddingVertical: 0,
    paddingHorizontal: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
    width: '100%',
  },
  catalogUnifiedSearchBoxWide: {
    borderRadius: 10,
    paddingVertical: 0,
  },
  catalogUnifiedSearchInput: {
    flex: 1,
    minWidth: 0,
    borderWidth: 0,
    backgroundColor: 'transparent',
    color: ticketColors.ink,
    paddingVertical: 0,
    paddingHorizontal: 4,
    fontSize: 14,
    fontFamily: ticketFonts.sans,
  },
  catalogUnifiedScanButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    flexShrink: 0,
    minWidth: 58,
    minHeight: 36,
    paddingVertical: 7,
    paddingHorizontal: 9,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  catalogUnifiedScanButtonWide: {
    minWidth: 74,
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
  catalogUnifiedScanLabel: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '900',
    fontSize: 12,
    letterSpacing: 0.4,
    fontFamily: ticketFonts.sans,
  },
  catalogMiniSearchLabel: {
    ...typography.caption,
    color: colors.textMuted,
    fontWeight: '700',
  },
  catalogPagerWrap: {
    marginTop: spacing.sm,
    gap: spacing.xs,
  },
  catalogPagerHint: {
    ...typography.caption,
    color: colors.textSecondary,
  },
  catalogPager: {
    flexDirection: 'row',
    gap: spacing.xs,
  },
  catalogPagerButton: {
    minHeight: 34,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
  },
  catalogPagerButtonDisabled: {
    opacity: 0.5,
  },
  catalogPagerButtonText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },
});
